import React from "react";

function Tagline() {
  return (
    <div className="overlay">
      <div className="first-heading" id="tagline">
        <div className="large-text">TRANSCENDING</div>
        <div className="large-text">DIGITAL TRANSFORMATION</div>
      </div>
    </div>
  );
}

export default Tagline;
